export const SOLUTION_TYPE = {
  SERVICE: 3,
};
